// extracted by mini-css-extract-plugin
export default {"searchPreviewWrapper":"SearchPreviews-searchPreviewWrapper"};